import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { trackViewContent, handlePurchaseCTA } from './utils/metaPixel';
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// META PIXEL BASE CODE — Synchronous, in <head>
// Pixel ID: 1672445733721265
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
const pixelScript = document.createElement('script');
pixelScript.textContent = `
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '1672445733721265');
fbq('track', 'PageView');
`;
document.head.appendChild(pixelScript);
// Noscript fallback
const noscript = document.createElement('noscript');
noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1672445733721265&ev=PageView&noscript=1" />`;
document.head.appendChild(noscript);
// Preconnect to external origins
const preconnects = ['https://connect.facebook.net', 'https://cdn.shopify.com', 'https://fonts.googleapis.com', 'https://fonts.gstatic.com'];
preconnects.forEach(href => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  link.crossOrigin = 'anonymous';
  document.head.prepend(link);
});
render(<App data-id="element-2" />, document.getElementById('root'));